const transitionTimingFunction = 'ease-in-out';
const transitionDuration = '300ms';
const transitionValue = `all ${transitionDuration} ${transitionTimingFunction}`;
const Animation = {
  transitionTimingFunction,
  transitionDuration,
  transitionValue,
};

export default Animation;
